<app-modal [dismissible]="false"
           (hide)="onModalClose()">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.tools.engrave.title' | translate }}</h5>
    </ng-container>
    <div class="body" modal-body>
        <app-tool-engrave [toolsToScan]="toolsToEngrave"
                          [isScanListenerActive]="isOpen"></app-tool-engrave>
    </div>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    (click)="close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button
            type="primary"
            (click)="onRegenerateDataMatrix()">
            {{ 'generic.buttons.regenerateDataMatrix' | translate }}
        </app-button>
    </div>
</app-modal>

<app-confirmation-modal
    (scanEvent)="onConfirmRegenerate($event)"
    [displayReasonMode]="true"
    [reasonMandatory]="true"
    [isCustomContent]="true"
    [isConfirmationInProgress]="isConfirmationInProgress"
    title="{{'admin.tools.regenerateMatrix.title' | translate}}"
    displayReasonLabel="{{'admin.tools.regenerateMatrix.label' | translate}}"
    displayReasonPlaceholder="{{'admin.tools.regenerateMatrix.placeholder' | translate}}"
>
    <div modal-custom-content>
        <p>{{ 'admin.tools.regenerateMatrix.message' | translate }}</p>
    </div>
</app-confirmation-modal>
